module.exports = __webpack_public_path__ + "media/images/home/cash-52344218c1c6344eab57554df0acd842.png";